import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import { ChevronDown, ChevronRight, People, Save, XCircle } from "react-bootstrap-icons";
import ReactSelect from "react-select";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { Modal } from "react-bootstrap";

import CustomDataTable from "../../../layouts/DataTables/CustomDataTable";
import { getDropdownList } from "../../Shared/dropdownListActions";
import axios from "../../../apis/Api";

const spotSaleFeatureName = "SpotSale Access";
const checkInFeatureName = "CheckIn Access";

const ProductConfiguration = (props) => {
  const { id } = useParams();
  const [featureList, setFeatureList] = useState([]);
  const [featureStatusList, setFeatureStatusList] = useState(null);
  const [centersList, setCentersList] = useState(null);
  const [spotSaleCenters, setSpotSaleCenters] = useState([]);
  const [spotSaleDlmsByCenter, setSpotSaleDlmsByCenter] = useState({});
  const [spotSaleLoadingCenterId, setSpotSaleLoadingCenterId] = useState(null);
  const [checkInCenters, setCheckInCenters] = useState([]);
  const [checkInDlmsByCenter, setCheckInDlmsByCenter] = useState({});
  const [checkInLoadingCenterId, setCheckInLoadingCenterId] = useState(null);
  const [userList, setUserList] = useState(null);
  const [centersLoaded, setCentersLoaded] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);

  const distributorId = props?.distributorMainInfo?.id || id;

  const customStyles = {
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const isSpotSaleFeature = (feature) =>
    feature?.name?.toLowerCase().replace(/\s/g, "").includes("spotsale");

  const isCheckInFeature = (feature) =>
    feature?.name?.toLowerCase().replace(/[^a-z]/gi, "").includes("checkin");

  const isConnectFeature = (feature) =>
    feature?.name?.toLowerCase().includes("connect");

  const normalizeDlmOptions = (response) => {
    const list = Array.isArray(response) ? response : response?.response || [];
    return list.map((item) => ({
      value: item.value || item.id || item.userId || item.deliveryManId,
      label:
    item.fullname ||
    item.username ||
    item.userName ||
    item.name ||
    item.deliveryManName ||
    item.text ||
    item.tillNo,
    })).filter((item) => item.value && item.label);
  };

  const getFeaturesList = () => {
    axios
      .get(`api/DistFeatureCategory`)
      .then(({ data }) => {
        if (data != null && data.length > 0) {
          const features = data
            .filter((feature) => !feature.name?.toLowerCase().includes("scr"))
            .map((feature) => ({
              ...feature,
              isExpanded: false,
              isChecked: false,
            }));

          const hasSpotSale = features.some(isSpotSaleFeature);
          const hasCheckIn = features.some(isCheckInFeature);

          const withSpotSale = hasSpotSale
            ? features
            : [...features, { id: null, name: spotSaleFeatureName, isExpanded: false, isChecked: false, isLocalOnly: true }];

          const withAll = hasCheckIn
            ? withSpotSale
            : [...withSpotSale, { id: null, name: checkInFeatureName, isExpanded: false, isChecked: false, isLocalOnly: true }];

          setFeatureList(withAll);
        }
      })
      .catch(function () {});
  };

  const getFeatureStatusList = () => {
    if (id) {
      axios
        .get(`api/DistFeatureCategoryStatus/DistributorCategoryStatus/${id}`)
        .then(({ data }) => {
          if (data?.response != null && data?.response?.length > 0) {
            setFeatureStatusList(data.response);
            const features = featureList.map((feature) => {
              const status = data.response.find(
                (row) => String(row.distFeatureCategoryId) === String(feature.id)
              );
              return {
                ...feature,
                isChecked: status ? status.enabledStatus : feature.isChecked,
              };
            });
            setFeatureList(features);
          } else {
            setFeatureStatusList([]);
          }
        })
        .catch(function () {});
    }
  };

  const getDistUserList = () => {
    if (id) {
      axios
        .get(`api/Distributor/GetDistributorUsers/${id}`)
        .then(({ data }) => {
          if (data != null && data?.response) {
            setUserList(data.response);
          }
        })
        .catch(function () {});
    }
  };

  const buildCenterRow = (center) => ({
    id: null,
    centerId: center.id,
    centerName: center.distCenterName,
    isActive: false,
    informationUserId: null,
    onlineOrderUserId: null,
    complaintUserId: null,
    otherUserId: null,
  });

  const getCenterList = () => {
    if (id) {
      axios
        .get(`api/DistCenter/GetDistributionCentersByDistributor/${id}`)
        .then(({ data }) => {
          if (data != null && data?.length > 0) {
            const centers = data.map(buildCenterRow);
            setCentersList(centers);
            const blankCenters = centers.map((center) => ({
              centerId: center.centerId,
              centerName: center.centerName,
              isActive: false,
              allowAllDlms: false,
              selectedDlms: [],
            }));
            setSpotSaleCenters(blankCenters);
            setCheckInCenters(blankCenters);
          }
        })
        .catch(function () {});
    }
  };

  const getDistributorTicketUserAllocations = () => {
    if (id) {
      axios
        .get(
          `api/VLCTicketCategoryUserAllocation/GetDistributorTicketUserAllocations/${id}`
        )
        .then(({ data }) => {
          setCentersLoaded(true);
          if (data != null && data.length > 0) {
            mapUserAllocations(data);
          }
        })
        .catch(function () {});
    }
  };

  const getSpotSaleConfiguration = () => {
    if (!id) return;

    axios
      .get(`api/DistFeatureCategoryStatus/GetSpotSaleAccessByDistributor/${id}`)
      .then(async ({ data }) => {
        debugger;
        const savedRows = data?.response || data || [];
        if (!Array.isArray(savedRows) || savedRows.length === 0) return;

        // Preload the DLM options for centers that have specific DLMs selected so we
        // can resolve the stored DlmUserId values into labelled select options.
        const optionsByCenter = {};
        await Promise.all(
          savedRows
            .filter((row) => !row.allowAllDlms && row.dlmUserIds)
            .map((row) =>
              fetchDlmOptions(row.distCenterId)
                .then((options) => {
                  optionsByCenter[row.distCenterId] = options;
                })
                .catch(() => {
                  optionsByCenter[row.distCenterId] = [];
                })
            )
        );

        setSpotSaleCenters((centers) =>
          centers.map((center) => {
            debugger;
            const saved = savedRows.find(
              (row) => String(row.distCenterId) === String(center.centerId)
            );

            if (!saved) return center;

            const allowAllDlms = saved.allowAllDlms || false;
            const dlmIds = (saved.dlmUserIds || "")
              .split(",")
              .map((value) => value.trim())
              .filter(Boolean);
            const options = optionsByCenter[center.centerId] || [];
            const selectedDlms = allowAllDlms
              ? []
              : dlmIds.map((idValue) => {
                  const match = options.find(
                    (option) => String(option.value) === String(idValue)
                  );
                  return match || { value: idValue, label: idValue };
                });

            return {
              ...center,
              isActive: saved.enabledStatus,
              wasActive: saved.enabledStatus,
              allowAllDlms,
              selectedDlms,
            };
          })
        );
      })
      .catch(function () {});
  };

  const getCheckInConfiguration = () => {
    if (!id) return;

    axios
      .get(`api/DistFeatureCategoryStatus/GetCheckInAccessByDistributor/${id}`)
      .then(async ({ data }) => {
        const savedRows = data?.response || data || [];
        if (!Array.isArray(savedRows) || savedRows.length === 0) return;

        const optionsByCenter = {};
        await Promise.all(
          savedRows
            .filter((row) => !row.allowAllDlms && row.dlmUserIds)
            .map((row) =>
              axios
                .get(`api/DistCenter/GetCenterDeliveryUsersDDL/${row.distCenterId}`)
                .then(({ data }) => {
                  const options = normalizeDlmOptions(data);
                  optionsByCenter[row.distCenterId] = options;
                  setCheckInDlmsByCenter((prev) => ({ ...prev, [row.distCenterId]: options }));
                })
                .catch(() => { optionsByCenter[row.distCenterId] = []; })
            )
        );

        setCheckInCenters((centers) =>
          centers.map((center) => {
            const saved = savedRows.find(
              (row) => String(row.distCenterId) === String(center.centerId)
            );
            if (!saved) return center;

            const allowAllDlms = saved.allowAllDlms || false;
            const dlmIds = (saved.dlmUserIds || "").split(",").map((v) => v.trim()).filter(Boolean);
            const options = optionsByCenter[center.centerId] || [];
            const selectedDlms = allowAllDlms
              ? []
              : dlmIds.map((idValue) => {
                  const match = options.find((o) => String(o.value) === String(idValue));
                  return match || { value: idValue, label: idValue };
                });

            return { ...center, isActive: saved.enabledStatus, wasActive: saved.enabledStatus, allowAllDlms, selectedDlms };
          })
        );
      })
      .catch(() => {});
  };

  const updateCheckInCenter = (centerId, updates) => {
    setCheckInCenters((centers) =>
      centers.map((center) =>
        String(center.centerId) === String(centerId) ? { ...center, ...updates } : center
      )
    );
  };

  const loadDlmsForCheckInCenter = (centerId) => {
    if (checkInDlmsByCenter[centerId]) return;

    setCheckInLoadingCenterId(centerId);
    axios
      .get(`api/DistCenter/GetCenterDeliveryUsersDDL/${centerId}`)
      .then(({ data }) => {
        const options = normalizeDlmOptions(data);
        setCheckInDlmsByCenter((prev) => ({ ...prev, [centerId]: options }));
      })
      .catch(() => toast.error("Unable to load DLMs for selected distribution center"))
      .finally(() => setCheckInLoadingCenterId(null));
  };

  const toggleCheckInCenter = (center) => {
    const nextValue = !center.isActive;

    if (nextValue) {
      confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: false,
        customUI: ({ onClose }) => (
          <div className="custom-ui">
            <Modal.Dialog>
              <Modal.Header>
                <Modal.Title>CheckIn Access</Modal.Title>
                <button type="button" onClick={onClose} className="btn-close" aria-label="Close" />
              </Modal.Header>
              <Modal.Body>
                <p>Do you want to allow access to all DLMs for this distribution center?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outline-primary" onClick={() => {
                  loadDlmsForCheckInCenter(center.centerId);
                  updateCheckInCenter(center.centerId, { isActive: true, allowAllDlms: true, selectedDlms: [] });
                  onClose();
                }}>Yes, Allow All</Button>
                <Button variant="primary" onClick={() => {
                  loadDlmsForCheckInCenter(center.centerId);
                  updateCheckInCenter(center.centerId, { isActive: true, allowAllDlms: false, selectedDlms: center.selectedDlms });
                  onClose();
                }}>No, Select DLMs</Button>
              </Modal.Footer>
            </Modal.Dialog>
          </div>
        ),
      });
      return;
    }

    updateCheckInCenter(center.centerId, { isActive: false, allowAllDlms: false, selectedDlms: [] });
  };

  const saveCheckInConfigurations = (feature) => {
    const selectedRows = checkInCenters.filter((c) => c.isActive);
    const incompleteRows = selectedRows.filter((c) => !c.allowAllDlms && c.selectedDlms.length === 0);

    if (incompleteRows.length > 0) {
      toast.error("Select all DLMs or choose at least one DLM for each enabled center");
      return;
    }

    const saveList = checkInCenters
      .filter((c) => c.isActive || c.wasActive)
      .map((c) => ({
        distributorId,
        distFeatureCategoryId: feature.id,
        distCenterId: c.centerId,
        enabledStatus: c.isActive,
        allowAllDlms: c.allowAllDlms,
        dlmUserIds: c.allowAllDlms ? "" : getIds(c.selectedDlms),
      }));

    axios
      .post("api/DistFeatureCategoryStatus/SaveCheckInAccess", saveList)
      .then(({ data }) => {
        if (data != null && data.statusCode === 200) {
          toast.success("CheckIn configurations saved");
          setCheckInCenters((centers) =>
            centers.map((c) => ({ ...c, wasActive: c.isActive }))
          );
        }
      })
      .catch(() => toast.error("Unable to save CheckIn configurations"));
  };

  const featureSave = (req, feature) => {
    axios
      .post(`api/DistFeatureCategoryStatus`, req)
      .then(({ data }) => {
        if (data != null && data.status === "Success") {
          toast.success("Feature right changed");
          setFeatureList((features) =>
            features.map((item) =>
              String(item.id) === String(feature.id)
                ? { ...item, isChecked: !item.isChecked }
                : item
            )
          );
        }
      })
      .catch(function () {});
  };

  const saveFeatureStatus = (feature) => {
    if (distributorId && feature?.id) {
      const req = {
        DistributorId: distributorId,
        DistFeatureCategoryId: feature.id,
        DistCenterId: null,
        EnabledStatus: !feature.isChecked,
      };

      featureSave(req, feature);
    }
  };

  const changeFeatureStatus = (feature) => {
    if (isSpotSaleFeature(feature)) {
      setFeatureList((features) =>
        features.map((item) =>
          item.name === feature.name
            ? { ...item, isChecked: !item.isChecked, isExpanded: !item.isChecked }
            : item
        )
      );
      return;
    }

    saveFeatureStatus(feature);
  };

  const alterExpand = (feature) => {
    setFeatureList((features) =>
      features.map((item) =>
        item.name === feature.name
          ? { ...item, isExpanded: !item.isExpanded }
          : item
      )
    );
  };

  const filterCenterUsers = (centerId) => {
    if (userList != null && userList.length > 0) {
      return userList
        .filter((user) => user.centerId.toLowerCase().includes(centerId))
        .map((user) => ({
          value: user.userId,
          label: user.userName,
        }));
    }

    return [];
  };

  const getIds = (users) => {
    if (!users) return "";
    if (typeof users === "string") return users;
    if (!Array.isArray(users)) {
      return users.value ? users.value.toString() : "";
    }
    if (users.length === 0) return "";
    return users.map((user) => user.value).join(",");
  };

  const selectAll = () => {
    if (centersList != null && centersList.length > 0) {
      const nextValue = !isSelectAll;
      setIsSelectAll(nextValue);
      setCentersList(
        centersList.map((center) => ({
          ...center,
          isActive: nextValue,
        }))
      );
    }
  };

  const selectRow = (row) => {
    setCentersList(
      centersList.map((center, index) =>
        index === Number(row.row.id) ? { ...center, isActive: !center.isActive } : center
      )
    );
  };

  const resetRow = (row) => {
    setCentersList(
      centersList.map((center, index) =>
        index === Number(row.row.id)
          ? {
            ...center,
            isActive: false,
            informationUserId: null,
            onlineOrderUserId: null,
            complaintUserId: null,
            otherUserId: null,
          }
          : center
      )
    );
    setIsSelectAll(false);
  };

  const resetAll = () => {
    setCentersList(
      centersList.map((center) => ({
        ...center,
        isActive: false,
        informationUserId: null,
        onlineOrderUserId: null,
        complaintUserId: null,
        otherUserId: null,
      }))
    );
    setIsSelectAll(false);
  };

  const assignUser = (row, value, type) => {
    setCentersList(
      centersList.map((center, index) => {
        if (index !== Number(row.id)) return center;

        return {
          ...center,
          informationUserId:
            type === "information" ? value : center.informationUserId,
          onlineOrderUserId: type === "online" ? value : center.onlineOrderUserId,
          complaintUserId:
            type === "complaint" ? value : center.complaintUserId,
          otherUserId: type === "other" ? value : center.otherUserId,
        };
      })
    );
  };

  const mapUserAllocations = (data) => {
    setCentersList((centers) =>
      centers.map((center) => {
        const row = data.find(
          (item) => String(item.distCenterId) === String(center.centerId)
        );
        if (row == null) return center;

        return {
          ...center,
          isActive: row.isActive,
          id: row.id,
          informationUserId: findUser(row.informationUserId),
          onlineOrderUserId: findUser(row.onlineOrderUserId),
          complaintUserId: findUser(row.complaintUserId),
          otherUserId: findUser(row.otherUserId),
        };
      })
    );
  };

  const findUser = (userIds) => {
    if (!userIds) return [];
    if (Array.isArray(userIds)) return userIds;
    const idsArray = userIds.split(",");
    return userList
      .filter((user) => idsArray.includes(user.userId.toString()))
      .map((user) => ({
        label: user.userName,
        value: user.userId,
      }));
  };

  const saveChanges = (feature) => {
    let saveList = [...centersList];
    saveList = saveList.map((center) => {
      const checkActive =
        (!center.informationUserId || center.informationUserId.length === 0) &&
        (!center.onlineOrderUserId || center.onlineOrderUserId.length === 0) &&
        (!center.complaintUserId || center.complaintUserId.length === 0) &&
        (!center.otherUserId || center.otherUserId.length === 0)
          ? false
          : center.isActive;

      return {
        id: center.id ? center.id : null,
        isActive: checkActive,
        distCenterId: center.centerId,
        informationUserId: getIds(center.informationUserId),
        onlineOrderUserId: getIds(center.onlineOrderUserId),
        complaintUserId: getIds(center.complaintUserId),
        otherUserId: getIds(center.otherUserId),
      };
    });

    axios
      .post(`api/VLCTicketCategoryUserAllocation`, saveList)
      .then(({ data }) => {
        if (data != null && data.status === "Success") {
          toast.success("Changes saved");
          saveFeatureStatus(feature);
        }
      })
      .catch(function () {});
  };

  const fetchDlmOptions = (centerId) =>
    axios
      .get(`api/DistCenter/GetCenterDeliveryUsersDDL/${centerId}`)
      .then(({ data }) => {
        const options = normalizeDlmOptions(data);
        setSpotSaleDlmsByCenter((current) => ({
          ...current,
          [centerId]: options,
        }));
        return options;
      });

  const loadDlmsForCenter = (centerId) => {
    if (spotSaleDlmsByCenter[centerId]) return;

    setSpotSaleLoadingCenterId(centerId);
    fetchDlmOptions(centerId)
      .catch(function () {
        toast.error("Unable to load DLMs for selected distribution center");
      })
      .finally(() => {
        setSpotSaleLoadingCenterId(null);
      });
  };

  const updateSpotSaleCenter = (centerId, updates) => {
    setSpotSaleCenters((centers) =>
      centers.map((center) =>
        String(center.centerId) === String(centerId) ? { ...center, ...updates } : center
      )
    );
  };

const toggleSpotSaleCenter = (center) => {
  const nextValue = !center.isActive;

  if (nextValue) {
    confirmAlert({
      closeOnEscape: true,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => (
        <div className="custom-ui">
          <Modal.Dialog>
            <Modal.Header>
              <Modal.Title>Spot Sale Access</Modal.Title>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                aria-label="Close"
              />
            </Modal.Header>

            <Modal.Body>
              <p>
                Do you want to allow access to all DLMs for this distribution
                center?
              </p>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="outline-primary"
                onClick={() => {
                  loadDlmsForCenter(center.centerId);

                  updateSpotSaleCenter(center.centerId, {
                    isActive: true,
                    allowAllDlms: true,
                    selectedDlms: [],
                  });

                  onClose();
                }}
              >
                Yes, Allow All
              </Button>

              <Button
                variant="primary"
                onClick={() => {
                  loadDlmsForCenter(center.centerId);

                  updateSpotSaleCenter(center.centerId, {
                    isActive: true,
                    allowAllDlms: false,
                    selectedDlms: center.selectedDlms,
                  });

                  onClose();
                }}
              >
                No, Select DLMs
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      ),
    });

    return;
  }

  updateSpotSaleCenter(center.centerId, {
    isActive: false,
    allowAllDlms: false,
    selectedDlms: [],
  });
};

  const resetSpotSaleConfiguration = () => {
    setSpotSaleCenters(
      spotSaleCenters.map((center) => ({
        ...center,
        isActive: false,
        allowAllDlms: false,
        selectedDlms: [],
      }))
    );
  };

  const saveSpotSaleConfigurations = (feature) => {
    debugger;
    const selectedRows = spotSaleCenters.filter((center) => center.isActive);
    const incompleteRows = selectedRows.filter(
      (center) => !center.allowAllDlms && center.selectedDlms.length === 0
    );

    if (incompleteRows.length > 0) {
      toast.error("Select all DLMs or choose at least one DLM for each enabled center");
      return;
    }

    const saveList = spotSaleCenters
      .filter((center) => center.isActive || center.wasActive)
      .map((center) => ({
      distributorId,
      distFeatureCategoryId: feature.id,
      distCenterId: center.centerId,
      enabledStatus: center.isActive,
      allowAllDlms: center.allowAllDlms,
      dlmUserIds: center.allowAllDlms ? "" : getIds(center.selectedDlms),
    }));

    axios
      .post(`api/DistFeatureCategoryStatus/SaveSpotSaleAccess`, saveList)
      .then(({ data }) => {
        debugger;
        if (data != null && (data.statusCode === 200)) {
          toast.success("Spot Sale configurations Saved");
          setSpotSaleCenters((centers) =>
            centers.map((center) => ({
              ...center,
              wasActive: center.isActive,
            }))
          );
        }
      })
      .catch(function () {
        toast.error("Unable to save Spot Sale configurations");
      });
  };

  const columns = useMemo(
    () => [
      {
        Header: (
          <div className="ms-2 my-2">
            <input
              checked={isSelectAll}
              value={isSelectAll}
              type="checkbox"
              onChange={selectAll}
              style={{ transform: "scale(1.3)" }}
            />{" "}
            <span className="ms-2">Distribution Center</span>
          </div>
        ),
        accessor: "centerId",
        disableSortBy: true,
        Cell: (row) => (
          <div className="ms-2 my-2" key={row.row.original.centerId}>
            <input
              checked={row.row.original.isActive}
              value={row.row.original.isActive}
              type="checkbox"
              onChange={() => selectRow(row)}
              style={{ transform: "scale(1.3)" }}
            />
            <span className="ms-2">{row.cell?.row?.original?.centerName}</span>
          </div>
        ),
      },
      {
        Header: "Information",
        accessor: "informationUserId",
        Cell: (row) => (
          <div className="form-group" onDoubleClick={(event) => event.stopPropagation()}>
            <ReactSelect
              id="informationUserId"
              name="informationUserId"
              className="basic-single"
              classNamePrefix="select"
              placeholder="Select User"
              isMulti={true}
              value={row.row.original.informationUserId}
              isDisabled={!row.row.original.isActive}
              isClearable={true}
              isSearchable={true}
              onChange={(option) => assignUser(row.row, option, "information")}
              options={filterCenterUsers(row.cell?.row?.original?.centerId)}
              menuPlacement="auto"
              styles={customStyles}
              menuPortalTarget={document.body}
            />
          </div>
        ),
      },
      {
        Header: "Online Orders",
        accessor: "onlineOrderUserId",
        Cell: (row) => (
          <div className="form-group" onDoubleClick={(event) => event.stopPropagation()}>
            <ReactSelect
              id="onlineOrderUserId"
              name="onlineOrderUserId"
              className="basic-single"
              classNamePrefix="select"
              placeholder="Select User"
              isMulti={true}
              value={row.row.original.onlineOrderUserId}
              isDisabled={!row.row.original.isActive}
              isClearable={true}
              isSearchable={true}
              onChange={(option) => assignUser(row.row, option, "online")}
              options={filterCenterUsers(row.cell?.row?.original?.centerId)}
              menuPlacement="auto"
              styles={customStyles}
              menuPortalTarget={document.body}
            />
          </div>
        ),
      },
      {
        Header: "Complaints",
        accessor: "complaintUserId",
        Cell: (row) => (
          <div className="form-group" onDoubleClick={(event) => event.stopPropagation()}>
            <ReactSelect
              id="complaintUserId"
              name="complaintUserId"
              className="basic-single"
              classNamePrefix="select"
              placeholder="Select User"
              isMulti={true}
              value={row.row.original.complaintUserId}
              isDisabled={!row.row.original.isActive}
              isClearable={true}
              isSearchable={true}
              onChange={(option) => assignUser(row.row, option, "complaint")}
              options={filterCenterUsers(row.cell?.row?.original?.centerId)}
              menuPlacement="auto"
              styles={customStyles}
              menuPortalTarget={document.body}
            />
          </div>
        ),
      },
      {
        Header: "Others",
        accessor: "otherUserId",
        Cell: (row) => (
          <div className="form-group" onDoubleClick={(event) => event.stopPropagation()}>
            <ReactSelect
              id="otherUserId"
              name="otherUserId"
              className="basic-single"
              classNamePrefix="select"
              placeholder="Select User"
              isMulti={true}
              value={row.row.original.otherUserId}
              isDisabled={!row.row.original.isActive}
              isClearable={true}
              isSearchable={true}
              onChange={(option) => assignUser(row.row, option, "other")}
              options={filterCenterUsers(row.cell?.row?.original?.centerId)}
              menuPlacement="auto"
              styles={customStyles}
              menuPortalTarget={document.body}
            />
          </div>
        ),
      },
      {
        Header: "Reset",
        accessor: "Reset",
        Cell: (row) => (
          <div className="form-group">
            <Button
              className="btn btn-default"
              onClick={() => resetRow(row)}
              style={{ fontSize: 15, margin: 0 }}
            >
              Reset
            </Button>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [centersList, isSelectAll, userList]
  );

  useEffect(() => {
    getDistUserList();
    getFeaturesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userList != null) {
      getCenterList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userList]);

  useEffect(() => {
    if (featureStatusList == null && featureList.length > 0) {
      getFeatureStatusList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureList]);

  useEffect(() => {
    if (centersList != null && centersList.length > 0 && !centersLoaded) {
      getDistributorTicketUserAllocations();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [centersList]);

  useEffect(() => {
    if (spotSaleCenters.length > 0) {
      getSpotSaleConfiguration();
      getCheckInConfiguration();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spotSaleCenters.length]);

  const renderFeaturePanel = (feature) => {
    if (isConnectFeature(feature)) {
      return (
        <CustomDataTable
          data={centersList ? centersList : []}
          columns={columns}
          IsSearchEnable={false}
          buttonRow={
            <div className="d-flex justify-content-end gap-2">
              {/* <Button className="btn btn-default" style={{ fontSize: 15, margin: 0 }} onClick={resetAll}>
                <XCircle className="me-1" />
                Reset
              </Button> */}
              <Button className="form-btn" variant="primary" style={{ fontSize: 15, margin: 0 }} onClick={() => saveChanges(feature)}>
                <Save className="me-1" />
                Save
              </Button>
            </div>
          }
        />
      );
    }

    if (isCheckInFeature(feature)) {
      return (
        <div style={styles.spotSalePanel}>
          <div style={styles.panelHeader}>
            <div>
              <h6 style={styles.panelTitle}>CheckIn Distribution Center Access</h6>
              <p style={styles.panelText}>
                Enable a distribution center, then allow all DLMs or select only the DLMs that should have CheckIn access.
              </p>
            </div>
            <span style={styles.selectedCount}>
              {checkInCenters.filter((c) => c.isActive).length} selected
            </span>
          </div>

          <div style={styles.centerGrid}>
            {checkInCenters.map((center) => {
              const dlmOptions = checkInDlmsByCenter[center.centerId] || [];
              return (
                <div key={center.centerId} style={styles.centerRow}>
                  <div style={styles.centerHeader}>
                    <label style={styles.checkboxLabel}>
                      <input
                        checked={center.isActive}
                        type="checkbox"
                        onChange={() => toggleCheckInCenter(center)}
                        style={styles.checkbox}
                      />
                      <span>{center.centerName}</span>
                    </label>
                    {center.isActive && <span style={styles.activeBadge}>Enabled</span>}
                  </div>

                  {center.isActive && (
                    <div style={styles.dlmBox}>
                      <div style={styles.infoMessage}>
                        <People className="me-2" />
                        Allow access to all DLMs, or turn it off and select specific DLMs.
                      </div>
                      <label style={styles.switchLine}>
                        <input
                          checked={center.allowAllDlms}
                          type="checkbox"
                          onChange={(e) =>
                            updateCheckInCenter(center.centerId, {
                              allowAllDlms: e.target.checked,
                              selectedDlms: e.target.checked ? [] : center.selectedDlms,
                            })
                          }
                        />
                        <span>Allow access to all DLMs</span>
                      </label>
                      {!center.allowAllDlms && (
                        <ReactSelect
                          id={`checkin-dlms-${center.centerId}`}
                          name={`checkin-dlms-${center.centerId}`}
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder={
                            String(checkInLoadingCenterId) === String(center.centerId)
                              ? "Loading DLMs..."
                              : "Select DLMs"
                          }
                          isMulti={true}
                          value={center.selectedDlms}
                          isClearable={true}
                          isSearchable={true}
                          isLoading={String(checkInLoadingCenterId) === String(center.centerId)}
                          onMenuOpen={() => loadDlmsForCheckInCenter(center.centerId)}
                          onChange={(option) =>
                            updateCheckInCenter(center.centerId, { selectedDlms: option || [] })
                          }
                          options={dlmOptions}
                          menuPlacement="auto"
                          styles={customStyles}
                          menuPortalTarget={document.body}
                        />
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div style={styles.actions}>
            <Button className="form-btn" variant="primary" onClick={() => saveCheckInConfigurations(feature)}>
              <Save className="me-1" />
              Save
            </Button>
          </div>
        </div>
      );
    }

    if (isSpotSaleFeature(feature)) {
      return (
        <div style={styles.spotSalePanel}>
          <div style={styles.panelHeader}>
            <div>
              <h6 style={styles.panelTitle}>Spot Sale Distribution Center Access</h6>
              <p style={styles.panelText}>
                Enable a distribution center, then allow all DLMs or select only the DLMs that should receive Spot Sale access.
              </p>
            </div>
            <span style={styles.selectedCount}>
              {spotSaleCenters.filter((center) => center.isActive).length} selected
            </span>
          </div>

          <div style={styles.centerGrid}>
            {spotSaleCenters.map((center) => {
              const dlmOptions = spotSaleDlmsByCenter[center.centerId] || [];
              return (
                <div key={center.centerId} style={styles.centerRow}>
                  <div style={styles.centerHeader}>
                    <label style={styles.checkboxLabel}>
                      <input
                        checked={center.isActive}
                        type="checkbox"
                        onChange={() => toggleSpotSaleCenter(center)}
                        style={styles.checkbox}
                      />
                      <span>{center.centerName}</span>
                    </label>
                    {center.isActive && (
                      <span style={styles.activeBadge}>Enabled</span>
                    )}
                  </div>

                  {center.isActive && (
                    <div style={styles.dlmBox}>
                      <div style={styles.infoMessage}>
                        <People className="me-2" />
                        Allow access to all DLMs, or turn it off and select specific DLMs.
                      </div>
                      <label style={styles.switchLine}>
                        <input
                          checked={center.allowAllDlms}
                          type="checkbox"
                          onChange={(event) =>
                            updateSpotSaleCenter(center.centerId, {
                              allowAllDlms: event.target.checked,
                              selectedDlms: event.target.checked ? [] : center.selectedDlms,
                            })
                          }
                        />
                        <span>Allow access to all DLMs</span>
                      </label>
                      {!center.allowAllDlms && (
                        <ReactSelect
                          id={`spot-sale-dlms-${center.centerId}`}
                          name={`spot-sale-dlms-${center.centerId}`}
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder={
                            String(spotSaleLoadingCenterId) === String(center.centerId)
                              ? "Loading DLMs..."
                              : "Select DLMs"
                          }
                          isMulti={true}
                          value={center.selectedDlms}
                          isClearable={true}
                          isSearchable={true}
                          isLoading={String(spotSaleLoadingCenterId) === String(center.centerId)}
                          onMenuOpen={() => loadDlmsForCenter(center.centerId)}
                          onChange={(option) =>
                            updateSpotSaleCenter(center.centerId, {
                              selectedDlms: option || [],
                            })
                          }
                          options={dlmOptions}
                          menuPlacement="auto"
                          styles={customStyles}
                          menuPortalTarget={document.body}
                        />
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div style={styles.actions}>
            {/* <Button className="btn btn-default" onClick={resetSpotSaleConfiguration}>
              <XCircle className="me-1" />
              Reset
            </Button> */}
            <Button className="form-btn" variant="primary" onClick={() => saveSpotSaleConfigurations(feature)}>
              <Save className="me-1" />
              Save
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div style={styles.productFeaturePanel}>
        <div>
          <h6 style={styles.panelTitle}>{feature.name}</h6>
          <p style={styles.panelText}>
            Current status: {feature.isChecked ? "Enabled" : "Disabled"}
          </p>
        </div>
        <Button className="form-btn" variant="primary" onClick={() => saveFeatureStatus(feature)}>
          <Save className="me-1" />
          Save
        </Button>
      </div>
    );
  };

  return (
    <div style={styles.page}>
      <Row>
        <Col>
          <div style={styles.heading}>
            <h5 style={styles.title}>Product Configuration</h5>
            <p style={styles.subtitle}>Manage product access and center-level assignments for this distributor.</p>
          </div>
        </Col>
      </Row>

      <div style={styles.featureList}>
        {featureList.map((feature) => (
          <div key={feature.id || feature.name} style={styles.featureCard}>
            <div style={styles.featureHeader}>
              <div style={styles.featureTitleBlock}>
                <button
                  type="button"
                  onClick={() => alterExpand(feature)}
                  style={styles.iconButton}
                  aria-label={feature.isExpanded ? "Collapse" : "Expand"}
                >
                  {feature.isExpanded ? <ChevronDown /> : <ChevronRight />}
                </button>
                <div>
                  <h6 style={styles.featureName}>{feature.name}</h6>
                  <span style={styles.featureMeta}>
                    {isSpotSaleFeature(feature) || isCheckInFeature(feature)
                      ? "Center and DLM access"
                      : "Distributor feature access"}
                  </span>
                </div>
              </div>

              {/* <label style={styles.toggleLabel}>
                <input
                  value={feature.isChecked}
                  checked={feature.isChecked}
                  onChange={() => changeFeatureStatus(feature)}
                  type="checkbox"
                  style={styles.toggle}
                />
                <span>{feature.isChecked ? "Enabled" : "Disabled"}</span>
              </label> */}
            </div>

            {feature.isExpanded && (
              <div style={styles.featureBody}>{renderFeaturePanel(feature)}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f8fafc",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: 18,
  },
  heading: {
    marginBottom: 18,
  },
  title: {
    color: "#111827",
    fontWeight: 700,
    margin: 0,
  },
  subtitle: {
    color: "#6b7280",
    margin: "4px 0 0",
  },
  featureList: {
    display: "grid",
    gap: 12,
  },
  featureCard: {
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    overflow: "hidden",
  },
  featureHeader: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    padding: "14px 16px",
  },
  featureTitleBlock: {
    alignItems: "center",
    display: "flex",
    gap: 10,
  },
  iconButton: {
    alignItems: "center",
    backgroundColor: "#eef2ff",
    border: "1px solid #c7d2fe",
    borderRadius: 8,
    color: "#3730a3",
    cursor: "pointer",
    display: "inline-flex",
    height: 34,
    justifyContent: "center",
    width: 34,
  },
  featureName: {
    color: "#111827",
    fontWeight: 700,
    margin: 0,
  },
  featureMeta: {
    color: "#6b7280",
    fontSize: 12,
  },
  toggleLabel: {
    alignItems: "center",
    color: "#374151",
    display: "flex",
    fontWeight: 600,
    gap: 8,
    margin: 0,
  },
  toggle: {
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  featureBody: {
    borderTop: "1px solid #e5e7eb",
    padding: 16,
  },
  spotSalePanel: {
    display: "grid",
    gap: 14,
  },
  panelHeader: {
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "space-between",
    gap: 14,
  },
  panelTitle: {
    color: "#111827",
    fontWeight: 700,
    margin: 0,
  },
  panelText: {
    color: "#6b7280",
    margin: "4px 0 0",
  },
  selectedCount: {
    backgroundColor: "#ecfdf5",
    border: "1px solid #a7f3d0",
    borderRadius: 999,
    color: "#047857",
    fontSize: 12,
    fontWeight: 700,
    padding: "5px 10px",
    whiteSpace: "nowrap",
  },
  centerGrid: {
    display: "grid",
    gap: 10,
  },
  centerRow: {
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: 12,
  },
  centerHeader: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    gap: 10,
  },
  checkboxLabel: {
    alignItems: "center",
    color: "#111827",
    display: "flex",
    fontWeight: 700,
    gap: 10,
    margin: 0,
  },
  checkbox: {
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  activeBadge: {
    backgroundColor: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: 999,
    color: "#1d4ed8",
    fontSize: 12,
    fontWeight: 700,
    padding: "4px 9px",
  },
  dlmBox: {
    backgroundColor: "#f9fafb",
    borderRadius: 8,
    display: "grid",
    gap: 10,
    marginTop: 12,
    padding: 12,
  },
  infoMessage: {
    alignItems: "center",
    color: "#4b5563",
    display: "flex",
    fontSize: 13,
  },
  switchLine: {
    alignItems: "center",
    color: "#374151",
    display: "flex",
    fontWeight: 600,
    gap: 8,
    margin: 0,
  },
  actions: {
    display: "flex",
    gap: 10,
    justifyContent: "flex-end",
  },
  productFeaturePanel: {
    alignItems: "center",
    display: "flex",
    gap: 12,
    justifyContent: "space-between",
  },
};

const mapStateToProps = (state) => {
  return {
    distributorMainInfo: state.distributorMainInfo
      ? state.distributorMainInfo
      : {},
  };
};

export default connect(mapStateToProps, {
  getDropdownList,
})(ProductConfiguration);
